import React from 'react';
import AnimationDevice from '../images/device-pile.png';

function Alert(){
    alert('Redirecting..');
    window.open("home", "_self");
}
function Header() {
    return (
        <div className='content2-heading' id='content2-box'>
            <div className='animation2'>
            <img className='animation-img2' src={AnimationDevice}/>
            </div>
            <h1>Download your shows to watch <span>offline</span>.</h1>
            <p className='content2-details'>Save your favourites easily and always have something to watch.</p>
            <div class="header-btns">
                <a href="#" target="_top">
                <button onClick={Alert} className='header-btn'>MORE&nbsp;&#9657;</button></a>
            </div>
        </div>
    );
}

export default Header;
